
		<base-modal
			[title]="title"
			[isLoading]="isLoading"
			[isBtnOkActive]="isBtnOkActive"
			[form]="form"
			(onOk)="ok()"
		>
			<form [formGroup]="form">
				<div class="form-group">
					<label for="name">
						name
					</label>
					
					<input
						type="text"
						class="form-control"
						id="name"
						formControlName="name"
						[formErrorIndicator]="name"
					/>
				</div>

				<div>
					<div class="form-group text-center">
						<button
							type="button"
							(click)="filter.changeRefererType('simple')"
							[class]="filter.filterParams.refererFilterType == 'simple' ? 'btn btn-light active' : 'btn btn-light'"
						>
							{{ 'adminstat.filterForm.simple' | translate }}
						</button>

						<button
							type="button"
							(click)="filter.changeRefererType('extended')"
							[class]="filter.filterParams.refererFilterType == 'extended' ? 'btn btn-light active' : 'btn btn-light'"
						>
							{{ 'adminstat.filterForm.extended' | translate }}
						</button>
					</div>

					<hr>

					<!--SIMPLE-->
					<ng-container
						*ngIf="filter.filterParams.refererFilterType == 'simple'"
					>
						<div class="form-group">
							<div class="row">
								<h6 class="col-xl-6 col-lg-12 control-label">
									{{ 'adminstat.filterForm.refererType' | translate }}
								</h6>

								<div class="col-xl-6 col-lg-12">
									<select
										class="form-control"
										[(ngModel)]="filter.filterParams.refererType"
										[ngModelOptions]="{standalone: true}"
										[sextant]="'filter-refererType'"
									>
										<option
											*ngFor="let opt of ['first', 'created', 'last', 'paid']"
											value="{{ opt }}"
											[selected]="opt == filter.filterParams.refererType"
										>
											{{ 'adminstat.filterForm.' + opt | translate }}
										</option>
									</select>
								</div>
							</div>
						</div>

						<div class="form-group">
							<div class="row">
								<h6 class="col-xl-6 col-lg-12 control-label">
									{{ 'adminstat.filterForm.refGroup' | translate }}
								</h6>

								<div class="col-xl-6 col-lg-12">
									<select
										class="form-control"
										[(ngModel)]="filter.filterParams.refGroup"
										[ngModelOptions]="{standalone: true}"
										[sextant]="'filter-refGroup'"
										(change)="filter.onRefGroupSelect($event.target.value)"
									>
										<option
											*ngFor="let opt of filter.refGroupList"
											value="{{ opt }}"
											[selected]="opt == filter.filterParams.refGroup"
										>
											{{ opt }}
										</option>
									</select>
								</div>
							</div>
						</div>

						<div class="form-group">
							<div class="row">
								<h6 class="col-xl-6 col-lg-12 control-label">{{ 'adminstat.filterForm.refSource' | translate }}</h6>
								<div class="col-xl-6 col-lg-12">
									<select class="form-control" [(ngModel)]="filter.filterParams.refSource"
											[ngModelOptions]="{standalone: true}" [sextant]="'filter-refSource'">
										<option *ngFor="let opt of ['all'].concat(filter.refSourceList)"
												value="{{ opt }}"
												[selected]="opt == filter.filterParams.refSource">{{ opt }}
										</option>
									</select>
								</div>
							</div>
						</div>

						<div class="form-group">
							<div class="row">
								<h6 class="col-xl-6 col-lg-12 control-label">URL</h6>
								<div class="col-xl-6 col-lg-12">
									<input class="form-control" [(ngModel)]="filter.filterParams.refUrl"
										   [ngModelOptions]="{standalone: true}">
								</div>
							</div>
						</div>
					</ng-container>

					<!--EXTENDED-->
					<div
						*ngIf="filter.filterParams.refererFilterType == 'extended'"
					>
						<div
							*ngFor="let f of filter.filterParams.refExtendedFilters; let i = index"
						>
							<input
								*ngIf="f.condition"
								type="hidden"
								[(ngModel)]="f.condition"
								[ngModelOptions]="{standalone: true}"
							>

							<b *ngIf="f.condition">
								{{ 'adminstat.filterForm.' + f.condition | translate }}
							</b>

							<ng-container *ngIf="f.condition == 'or'">
								<br><br>
							</ng-container>

							<hr *ngIf="f.condition == 'and'">

							<div class="form-group" *ngIf="!f.condition">
								<div class="row">
									<h6 class="col-xl-6 col-lg-12 control-label">
										{{ 'adminstat.filterForm.refererType' | translate }}
									</h6>

									<div class="col-xl-6 col-lg-12">
										<select
											class="form-control"
											[(ngModel)]="f.refererType"
											[ngModelOptions]="{standalone: true}"
										>
											<option
												*ngFor="let opt of filter.refererTypes"
												value="{{ opt }}"
												[selected]="opt == f.refererType"
											>
												{{ 'adminstat.filterForm.' + opt | translate }}
											</option>
										</select>
									</div>
								</div>
							</div>

							<div class="form-group" *ngIf="!f.condition">
								<div class="row">
									<h6 class="col-xl-6 col-lg-12 control-label">
										{{ 'adminstat.filterForm.option' | translate }}
									</h6>

									<div class="col-xl-6 col-lg-12">
										<select
											class="form-control"
											[(ngModel)]="f.searchByMarkUtm"
											[ngModelOptions]="{standalone: true}"
										>
											<option
												*ngFor="let opt of helper.getUtmList().concat(['referal'])"
												value="{{ opt }}"
												[selected]="opt == f.searchByMarkUtm"
											>
												{{ opt }}
											</option>
										</select>
									</div>
								</div>
							</div>

							<div class="form-group" *ngIf="!f.condition">
								<div class="row">
									<h6 class="col-xl-6 col-lg-12 control-label">
										{{ 'adminstat.filterForm.match type' | translate }}
									</h6>

									<div class="col-xl-6 col-lg-12">
										<select class="form-control" [(ngModel)]="f.searchByMarkRule"
												[ngModelOptions]="{standalone: true}">
											<option
												*ngFor="let opt of filter.refExtendedFilterOperators"
												value="{{ opt }}"
												[selected]="opt == f.searchByMarkRule"
											>
												{{ 'adminstat.users.group_ref_new.' + opt | translate }}
											</option>
										</select>
									</div>
								</div>
							</div>

							<div class="form-group" *ngIf="!f.condition">
								<div class="row">
									<h6 class="col-xl-6 col-lg-12 control-label">
										{{ 'adminstat.filterForm.value' | translate }}
									</h6>

									<div class="col-xl-6 col-lg-12">
										<input
											class="form-control"
											[(ngModel)]="f.refererSearchValue"
											[ngModelOptions]="{standalone: true}"
											[attr.index]="i"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</base-modal>
	